import {
  TextField,
  Button,
  Switch,
  FormControlLabel,
  Tooltip,
  Divider,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import DeleteIcon from "@mui/icons-material/DeleteOutline";
import { DataGrid } from "@mui/x-data-grid";

const ActividadesEconomicas = ({
  GActEco,
  setGActEco,
  actividades,
  setActividades,
  upper,
  setUpper,
  addActividad,
  eliminar,
  toggleActModal,
  tooltip,
  toggleTooltip,
}) => {
  const columns = [
    { field: "codigo", headerName: "CÓDIGO", width: 150 },
    { field: "descripcion", headerName: "ACTIVIDAD ECONÓMICA", flex: 1 },
    {
      field: "primario",
      headerName: "PRIMARIO",
      width: 120,
      renderCell: (params) => (
        <Switch
          checked={params.value}
          // onChange={() => handlePrimaryToggle(params.row.id)}
        />
      ),
    },
    {
      field: "actions",
      headerName: "",
      width: 120,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <Button
          size="small"
          color="secondary"
          onClick={() => eliminar(params.row)}
          sx={{ minWidth: "auto", p: 1 }}
        >
          <Tooltip title="Eliminar">
            <DeleteIcon />{" "}
          </Tooltip>
        </Button>
      ),
    },
  ];

  const handleCheckBox = () => {
    const newUpper = !upper;
    setUpper(newUpper);
    if (GActEco.codigo !== "") {
      setGActEco((prev) => ({
        ...prev,
        descripcion: newUpper
          ? prev.descripcion.toUpperCase()
          : prev.descripcion,
      }));
    }
  };

  return (
    <form>
      <Grid container spacing={2} sx={{ mt: 2 }}>
        <Grid size={12}>
          <Grid container alignItems="flex-end" spacing={2} sx={{ mb: 2 }}>
            <Grid size={{ xs: 12, sm: 4, md: 2 }}>
              <Divider sx={{ mb: 2 }}>Gestión de Actividades</Divider>
            </Grid>
            <Grid size={{ xs: 12, sm: 4, md: 2 }}>
              <TextField
                fullWidth
                label="Código"
                name="codigo"
                value={GActEco.codigo}
                disabled
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 4, md: 3 }}>
              <TextField
                fullWidth
                label="Descripción"
                name="descripcion"
                value={GActEco.descripcion}
                disabled
              />
            </Grid>
            <Grid size={{ xs: 4, sm: 4, md: 1 }}>
              <Tooltip
                title={!upper ? "Grabar en Mayúsculas" : "Quitar Mayúsculas"}
                placement="top"
              >
                <FormControlLabel
                  control={
                    <Switch
                      checked={upper}
                      onChange={handleCheckBox}
                      name="uppercase"
                      id="uppercase"
                      color="primary"
                    />
                  }
                  label=""
                />
              </Tooltip>
            </Grid>
            <Grid size={{ xs: 4, sm: 4, md: 1 }}>
              <Button variant="outlined" color="primary" onClick={addActividad}>
                AGREGAR
              </Button>
            </Grid>
            <Grid size={{ xs: 4, sm: 4, md: 1 }}>
              <Button
                variant="outlined"
                color="primary"
                onClick={toggleActModal}
              >
                <DeleteIcon />
              </Button>
            </Grid>
          </Grid>
        </Grid>

        <Grid item size={12} sx={{ height: 400, width: "100%", mt: 3 }}>
          <DataGrid
            rows={actividades.map((item, index) => ({ id: index, ...item }))}
            columns={columns}
            pageSize={5}
            rowsPerPageOptions={[5, 10, 20]}
            disableSelectionOnClick
          />
        </Grid>
      </Grid>
    </form>
  );
};

export default ActividadesEconomicas;
